(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('ak-mobile-nav-toggle');
    var closeBtn = document.getElementById('ak-mobile-nav-close');
    var drawer = document.getElementById('ak-mobile-nav');
    var scrim = document.getElementById('ak-mobile-nav-scrim');
    var header = document.querySelector('.ak-header');
    if (!toggle || !drawer || !scrim) return;

    var mq = window.matchMedia('(max-width: 1024px)');

    function openDrawer() {
      document.body.classList.add('ak-mobile-nav-open');
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      document.body.classList.remove('ak-mobile-nav-open');
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    drawer.querySelectorAll('.ak-mobile-nav__group-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.ak-mobile-nav__group');
        var isOpen = group.classList.contains('is-open');
        group.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    mq.addEventListener('change', function () {
      if (!mq.matches) closeDrawer();
    });

    // FUN60バナーが画面から消えたらヘッダーを隠し、再度見えたら表示(PC/モバイル共通)
    var fun60 = document.querySelector('.ak-banner--centered_bg');
    if (header && fun60 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // 上方向へスクロールして通り過ぎた(bottom < 0)場合だけ隠す。
        // まだ下にあってこれから見える場合(isIntersecting=falseだがtop>0)は隠さない。
        if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      }, { threshold: 0 });
      io.observe(fun60);
    } else if (header) {
      // FUN60が無いページ(商品ページ等)向けフォールバック: 下スクロールで隠し、上スクロールで再表示
      var getY = function () { return window.scrollY || document.documentElement.scrollTop || 0; };
      var lastY = getY();
      window.addEventListener('scroll', function () {
        var y = getY();
        if (y > lastY + 4 && y > 80) header.classList.add('is-hidden');
        else if (y < lastY - 2 || y <= 10) header.classList.remove('is-hidden');
        lastY = y;
      }, { passive: true });
    }
  });
})();
